<template>
    <b-card no-body>
        <b-tabs content-class="mt-3">
            <b-tab title="Devoluções">
                <b-card-body>
                    <b-card bg-variant="light">
                        <b-form-row class="mb-2" @keyup.enter="load">
                            <b-col lg="3" sm="12">
                                <lg-form-select v-model="form.status" :loadFunction="listStatus"
                                    labelFormGroupBind="Status:" label="descricao" description="" @input="load" />
                            </b-col>

                            <b-col lg="5" sm="12">
                                <LgFinderPageAlmoxarifado id="finderAlmoxarifado" @onselect="handleSelectAlmoxarifado"
                                    v-model="form.almoxarifado" invalidFeedback="almoxarifado deve ser informado!"
                                    label="Almoxarifado:" :prefix="prefix + title + ' > '" />
                            </b-col>

                            <b-col lg="3" sm="12" class="d-flex justify-content-end align-items-end">
                                <b-button id="limparDevolucao" class="mx-1" style="height: 20px;" size="sm" pill
                                    @click="clearForm" title="Limpar">
                                    <div class="btn-size-alinhamento">

                                        <b-icon icon="eraser" />

                                    </div>
                                    <b-tooltip target="limparDevolucao" title="Limpar"></b-tooltip>
                                </b-button>

                                <b-button id="localizarDevolucao" style="height: 20px;" class="mt-3" size="sm" pill
                                    variant="primary" @click="load" title="Buscar">
                                    <div class="btn-size-alinhamento">

                                        <b-icon icon="search" />
                                    </div>
                                    <b-tooltip target="localizarDevolucao" title="Localizar"></b-tooltip>
                                </b-button>

                                <b-button id="btnAdd" style="height: 20px;" class="mx-1" size="sm" pill
                                    variant="success" @click="showDevolucaoModal" title="Adicionar nova...">
                                    <div class="btn-size-alinhamento">

                                        <b-icon icon="plus" />
                                    </div>
                                    <b-tooltip :target="`btnAdd`" title="Adicionar novo.."></b-tooltip>
                                </b-button>
                            </b-col>
                        </b-form-row>

                        <b-form-row>
                            <b-col lg="2" sm="12" style="margin-right:-20px">
                                <lg-form-date invalidFeedback="A Data de Criação deve ser informada!"
                                    v-model="form.dataDe" label="Criação:" description="" />
                            </b-col>

                            <b-col lg="2" sm="12">
                                <lg-form-date invalidFeedback="A data limite deve ser informada!" v-model="form.dataAte"
                                    label="Até" description="" />
                            </b-col>

                            <b-col lg="4" sm="12" class="ml-3">
                                <lg-finder-page-produto id="finderProduto" @onselect="handleSelectProduto"
                                    v-model="form.produto" invalidFeedback="Produto deve ser informado!"
                                    :prefix="prefix + title + ' > '" />
                            </b-col>
                        </b-form-row>
                        <b-table responsive class="mt-4" small :busy="this.busy" :items="safeRecords"
                            :fields="tableFields" hover show-empty>
                            <template #table-busy>
                                <div class="text-center text-primary my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                </div>
                            </template>

                            <template v-slot:cell(id)="row">
                                <a v-b-tooltip.hover.top="'Detalhes da Devolução...'" class="link"
                                    @click.prevent="detalharDevolucao(row.item)">{{
                                        row.item.id
                                    }}</a>
                            </template>

                            <template #empty>
                                <p>Nenhum registro encontrado</p>
                            </template>

                            <template v-slot:cell(enviar)="row">
                                <b-button :id="row.index + `enviar`" @click="enviarDevolucao(row.item)" class="my-2"
                                    size="sm" pill variant="primary"
                                    v-if="row.item.status && emDigitacao(row.item.status) && row.item.departamento.id == form.departamento.id">
                                    <b-icon icon="box-arrow-right" />
                                    <b-tooltip :target="row.index + `enviar`" title="Enviar..."></b-tooltip>
                                </b-button>
                            </template>

                            <template v-slot:cell(editar)="row">
                                <b-button :id="row.index + `editar`" class="my-2" size="sm"
                                    @click="editarDevolucao(row.item)" pill variant="primary"
                                    v-if="temPrivilegioEdicao() && row.item.status && emDigitacao(row.item.status) && row.item.departamento.id == form.departamento.id">
                                    <b-icon icon="pencil-square" />
                                    <b-tooltip :target="row.index + `editar`" title="Editar...">
                                    </b-tooltip>
                                </b-button>
                            </template>

                            <template v-slot:cell(remover)="row">
                                <b-button :id="row.index + `remover`" @click="excluirDevolucao(row.item)" class="my-2"
                                    size="sm" pill variant="primary"
                                    v-if="row.item.status && emDigitacao(row.item.status) && row.item.departamento.id == form.departamento.id">
                                    <b-icon icon="trash2" />
                                    <b-tooltip :target="row.index + `remover`" title="Remover..."></b-tooltip>
                                </b-button>
                            </template>
                        </b-table>

                        <b-row class="mt-3" v-if="hasRecords">
                            <b-col cols="6" class="d-flex align-items-center" style="font-size: 12px">
                                Página {{ page }} de {{ totalPage }} - {{ total }} registros
                                <b-form-select size="sm" v-model="perPage" @change="load" :options="perPageOptions"
                                    class="ml-2" />
                            </b-col>
                            <b-col cols="6" class="d-flex justify-content-end">
                                <b-pagination v-model="page" :per-page="perPage" :total-rows="total" class="my-2" />
                            </b-col>
                        </b-row>
                        <DevolucaoForm v-if="showModalDevolucaoForm" @close="cancelar" @hidden="cancelar"
                            :prefix="prefix + title + ' > '" :id="devolucaoId" @submit="load" />
                        <ToggleDevolucao :prefix="prefix + title + ' > '" v-if="showModalToggleDevolucao"
                            @close="cancelar" @hidden="cancelar" :devolucao="devolucao" />
                    </b-card>
                </b-card-body>
            </b-tab>
            <b-tab :title="`Tarefas (${this.tarefasAguardando})`">
                <TarefaList />
            </b-tab>
        </b-tabs>
    </b-card>
</template>

<script>
import LgFinderPageAlmoxarifado from "@/components/Finders/LgFinderPageAlmoxarifado.vue"
import LgFinderPageProduto from "@/components/Finders/LgFinderPageProduto.vue"
import ResourceService from "@/core/api/ResourceService"
import LgFormDate from "@/core/components/Form/LgFormDate.vue"
import LgFormSelect from "@/core/components/Form/LgFormSelect.vue"
import ConfirmMixin from "@/core/mixins/confirm"
import { FormResourceMixin, ListResourceMixin } from "@/core/mixins/resource"
import moment from "moment"
import Swal from "sweetalert2"
import DevolucaoForm from "./DevolucaoForm.vue"
import TarefaList from "./TarefaList.vue"
import StatusEnum from "@/core/utils/StatusEnum"
import StatusDevolucaoEnum from "@/core/utils/StatusDevolucaoEnum"
import ToggleDevolucao from "./ToggleDevolucao.vue"
import verificaPrivilegio from "@/utils/VerificaPrivilegio"
import PrivilegiosEnum from "@/core/utils/PrivilegioEnum"




export default {
    components: {
        TarefaList,
        DevolucaoForm,
        LgFormDate,
        LgFormSelect,
        LgFinderPageAlmoxarifado,
        LgFinderPageProduto,
        ToggleDevolucao,
    },

    props: {
        title: {
            type: String,
            default: "Devolução",
        },
        prefix: {
            type: String,
            default: "",
        },
    },

    created() {
        const brand = JSON.parse(localStorage.getItem("context"))
        this.form.departamento = brand.departamento
    },

    data() {
        return {
            deveExecutarMetodo: false,

            perPage: 10,
            busy: false,
            perPageOptions: [10, 25, 50, 100],
            showModalDevolucaoForm: false,
            showModalTarefaAprovacao: false,
            showModalToggleDevolucao: false,
            devolucaoId: null,
            tarefasAguardando: 0,
            form: {
                id: "",
                dataDe: "",
                dataAte: "",
                almoxarifado: {},
                departamento: {},
                produto: {},
                status: { id: null, descricao: "Selecione..." },
            },
            records: [],
            total: 0,
            totalPage: 1,
        }
    },

    mixins: [ConfirmMixin, ListResourceMixin, FormResourceMixin],

    beforeMount() {
        this.$service = new ResourceService(`/api/devolucoes`)
        this.$statusService = new ResourceService(`/api/status/tipo/11`)
        this.$serviceStatus = new ResourceService(`/api/status`)
        this.$serviceTarefa = new ResourceService(`/api/tarefadevolucao`)

        this.load();
    },

    watch: {
        departamentoFromStore(departamento) {
            this.form.departamento = departamento
            this.load()
        },

        page() {
            this.load()
        },
    },

    computed: {
        departamentoFromStore() {
            return this.$store.getters.getMenuDepartamento
        },

        safeRecords() {
            return this.records || []
        },

        hasRecords() {
            return Array.isArray(this.records) && this.records.length > 0
        },

        tableFields() {
            return [
                {
                    key: "id",
                    label: "Número",
                    thStyle: "width: 7%; font-size: 16px; font-weight: 600;",
                    tdStyle: "width: 7%; font-size: 13px",
                },

                {
                    key: "justificativa",
                    label: "Justificativa",
                    thStyle: "font-size: 16px; font-weight: 600;",
                    tdStyle: "font-size: 13px",
                },

                {
                    key: "dhCriacao",
                    label: "Data Criação",
                    formatter: value => moment(value).format("DD/MM/yyyy"),
                    tdClass: "text-center",
                    thClass: "text-center",
                    thStyle: "width: 10%; font-size: 16px; font-weight: 600;",
                    tdStyle: "width: 10%; font-size: 13px",
                },

                {
                    key: "status.descricao",
                    label: "Status",
                    tdClass: "text-center",
                    thClass: "text-center",
                    thStyle: "width: 20%; font-size: 16px; font-weight: 600;",
                    tdStyle: "width: 20%; font-size: 13px",
                },
                {
                    key: "editar",
                    label: "",
                    thStyle: "width: 2%; font-size: 16px; ",
                    tdStyle: "width: 2%; font-size: 16px; ",
                    tdClass: "text-center ",
                },

                {
                    key: "enviar",
                    label: "",
                    thStyle: "width: 2%; font-size: 16px; ",
                    tdStyle: "width: 2%; font-size: 16px; ",
                    tdClass: "text-center ",
                },
                {
                    key: "remover",
                    label: "",
                    thStyle: "width: 2%; font-size: 16px; ",
                    tdStyle: "width: 2%; font-size: 16px; ",
                    tdClass: "text-center ",
                },
            ]
        },
    },

    methods: {


        temPrivilegioEdicao() {
            return verificaPrivilegio(PrivilegiosEnum.GERENCIAR_ALMOXARIFADO);

        },

        async load() {
            const filtro = {}


            if (
                this.form.produto != undefined &&
                this.form.produto.id != undefined &&
                this.form.produto.id != ""
            ) {
                filtro.produtoId = this.form.produto.id
            }

            if (
                this.form.almoxarifado != undefined &&
                this.form.almoxarifado.id != undefined &&
                this.form.almoxarifado.id != ""
            ) {
                filtro.almoxarifadoId = this.form.almoxarifado.id
            }

            if (
                this.form.departamento != undefined &&
                this.form.departamento.id != undefined &&
                this.form.departamento.id != ""
            ) {
                filtro.departamentoId = this.form.departamento.id
            }

            if (this.form.dataDe != "" && this.form.dataDe != undefined) {
                filtro.dataDe = new Date(this.form.dataDe).toLocaleDateString('pt-BR', {
                    timeZone: 'UTC'
                });
            }

            if (this.form.dataAte != "" && this.form.dataAte != undefined) {
                filtro.dataAte = new Date(this.form.dataAte).toLocaleDateString('pt-BR', {
                    timeZone: 'UTC'
                });
            }


            if (this.form.dataDe && this.form.dataAte) {
                const ini = new Date(this.form.dataDe);
                const fim = new Date(this.form.dataAte);

                if (ini > fim) {
                    this.busy = false;
                    this.$notify({
                        type: "danger",
                        message: "Informe as datas corretamente.",
                    });
                    return;
                }
            }

            if (this.form.status && this.form.status.id) {
                filtro.statusId = this.form.status.id
            }

            this.busy = true

            this.countTarefasAguardando(true)

            await this.$loadResource({
                size: this.perPage,
                page: this.page,
                params: filtro,
            });

            this.busy = false
        },

        clearForm() {
            this.devolucaoId = null
            this.form.almoxarifado = {}
            this.form.produto = {}
            this.form.status = { id: null, descricao: "Selecione..." }
            this.form.dataDe = ""
            this.form.dataAte = ""
            this.load()
        },

        async handleSelectProduto(produto) {
            this.form.produto = produto
            this.load()
        },

        async handleSelectAlmoxarifado(almoxarifado) {
            this.form.almoxarifado = almoxarifado
            this.load()
        },

        showDevolucaoModal() {
            this.showModalDevolucaoForm = true
        },

        cancelar() {
            this.showModalDevolucaoForm = false
            this.showModalToggleDevolucao = false
            this.clearForm()
        },

        async listStatus({ filter, page = 1 }) {
            return this.$statusService.findAll({ filter, page, limit: 5 })
        },

        async editarDevolucao(devolucao) {
            this.devolucaoId = devolucao.id
            this.showModalDevolucaoForm = true
        },

        detalharDevolucao(devolucao) {
            this.devolucao = devolucao
            this.showModalToggleDevolucao = true
        },

        async enviarDevolucao({ id }) {
            const value = await Swal.fire({
                title: `Enviar Devolução ${id}?`,
                text: "Essa ação não poderá ser desfeita.",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Sim",
                cancelButtonText: "Não",
            }).then(({ value }) => {
                return value
            })

            if (!value) {
                return
            }

            try {
                this.busy = true;
                await this.$service.post(`${id}/enviar`, {})
                this.busy = false
                this.load()
                this.$notify({
                    type: "success",
                    message: `Devolucao ${id} enviado!`,
                });
                this.deveExecutarMetodo = true;
                this.countTarefasAguardando(false);
            } catch (err) {
                this.$notify({
                    type: "danger",
                    message: `Erro ao enviar a devolucao ${id}!`,
                })
            }
        },

        async countTarefasAguardando(busy) {
            const filtro = {
                statusId: StatusEnum.TAREFA_AGUARDANDO.value,
            }

            if (!busy)
                this.busy = true;

            await this.$serviceTarefa.countByStatus(filtro).then(response => {
                if (!busy)
                    this.busy = false;
                if (response) {
                    this.tarefasAguardando = response.data
                } else {
                    this.tarefasAguardando = 0
                }
            })
        },

        async excluirDevolucao(devolucao) {
            const value = await Swal.fire({
                title: `Excluir devolucao ${devolucao.id}?`,
                text: "Esta ação não poderá ser desfeita!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Sim",
                cancelButtonText: "Não",
            }).then(({ value }) => {
                return value
            })

            if (!value) {
                return
            }

            try {
                await this.$service.remove(devolucao.id)
                this.load()
                this.$notify({
                    type: "success",
                    message: `Devolucao ${devolucao.id} excluído!`,
                })
            } catch (err) {
                this.$notify({
                    type: "danger",
                    message: `Erro ao excluir a devolucao ${devolucao.id}!`,
                })
            }
        },

        emDigitacao(status) {
            return status.id === StatusDevolucaoEnum.EM_DIGITACAO.cod
        },
    },

    filters: {
        date(value) {
            return moment(value).format("DD/MM/yyyy")
        },
    },
}
</script>

<style scoped>
.cursor-pointer {
    cursor: pointer;
}

.link {
    color: #0000ff;
    cursor: pointer;
}
</style>
